import { render, staticRenderFns } from "./ProfileTwitterFeed.vue?vue&type=template&id=bf793472&"
import script from "./ProfileTwitterFeed.vue?vue&type=script&lang=js&"
export * from "./ProfileTwitterFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports